import Typography from '../constants/Typography';

/**
 * Base modal style definitions shared across multiple modal components
 * (NoteDetailModal, AddNewNoteModal, IndirectActivityModal,
 *  ChangeRepairReasonModal, ChangeWOStatusModal, ConfirmpartsRequest,
 *  PartsOwnRequestModal, etc.).
 * Returns a plain object (not a StyleSheet) so it can be spread into each
 * modal's own StyleSheet.create call.
 */
export const createModalBaseStyles = (theme: any) => ({
  header: {
    flexDirection: 'row' as const,
    justifyContent: Typography.contentAlign.spaceBetween,
    alignItems: Typography.textAlign.centerAlign,
    paddingHorizontal: Typography.padding.padding24,
  },
  title: {
    fontSize: Typography.fontSize.fontSize24,
    fontWeight: Typography.fontWeight.semiBold,
    fontFamily: Typography.fontFamily.rethinkSans,
    color: theme.notedModalMainTitle,
    lineHeight: Typography.lineHeight.lineHeight36,
  },
  noteLogText: {
    fontSize: Typography.fontSize.fontSize14,
    fontFamily: Typography.fontFamily.inter,
    fontWeight: Typography.fontWeight.semiBold,
    lineHeight: Typography.lineHeight.lineHeight16,
    color: theme.createdKey,
  },
  selectedCard: {
    borderColor: theme.selectedtabBorder,
    backgroundColor: theme.selectedtabBGColor,
  },
  noteLogTitleText: {
    fontSize: Typography.fontSize.fontSize14,
    fontFamily: Typography.fontFamily.inter,
    fontWeight: Typography.fontWeight.medium,
    lineHeight: Typography.lineHeight.lineHeight20,
    color: theme.woStatusTitle,
    textAlign: Typography.textAlign.centerAlign,
  },
  cancelContainerStyle: {
    backgroundColor: 'transparent',
    borderColor: theme.cancelCTABorder,
    borderWidth: Typography.borderWidth.borderWidth1,
  },
  cancelCustomTextStyle: {
    color: theme.cancelCTAText,
    fontSize: Typography.fontSize.fontSize14,
    fontWeight: Typography.fontWeight.medium,
    fontFamily: Typography.fontFamily.inter,
  },
  saveContainerStyle: {
    backgroundColor: theme.listeningEnabledCTABG,
    borderColor: theme.cancelCTABorder,
    borderWidth: Typography.borderWidth.borderWidth1,
  },
  saveCustomTextStyle: {
    color: theme.listeningEnabledCTAText,
    fontSize: Typography.fontSize.fontSize14,
    fontWeight: Typography.fontWeight.medium,
    fontFamily: Typography.fontFamily.inter,
  },
  disabledSaveContainerStyle: {
    backgroundColor: theme.saveNoteCTADisabledBG,
    borderColor: theme.cancelCTABorder,
    borderWidth: Typography.borderWidth.borderWidth1,
  },
  disabledSaveCustomTextStyle: {
    color: theme.saveNoteCTADisabledText,
    fontSize: Typography.fontSize.fontSize14,
    fontWeight: Typography.fontWeight.medium,
    fontFamily: Typography.fontFamily.inter,
  },
});